import { useTranslation } from '@klv/hooks/useTranslation';

import * as styles from './styles/taxonomySubhead.module.scss';

import type { ITaxonomySubheadProps } from './types';

export const TaxonomySubhead = ({
  customers,
  industries,
  platforms,
}: ITaxonomySubheadProps) => {
  const { t } = useTranslation();

  const customer = customers?.nodes?.[0]?.name || '';
  const industry = industries?.nodes[0]?.name || '';
  const platform = platforms?.nodes[0]?.name || '';
  const hasCaseStudyTaxonomy = Boolean(customer || industry || platform);

  if (!hasCaseStudyTaxonomy) return null;

  return (
    <div className={styles.taxonomySubhead}>
      {customer && (
        <span>
          <strong>{`${t('templates_caseStudy_customer')}`}: </strong>
          {customer}
        </span>
      )}
      {industry && (
        <span>
          <strong>{`${t('templates_caseStudy_industry')}`}: </strong>
          {industry}
        </span>
      )}
      {platform && (
        <span>
          <strong>{`${t('templates_caseStudy_platform')}`}: </strong>
          {platform}
        </span>
      )}
    </div>
  );
};

export default TaxonomySubhead;
